import { createAction, props } from '@ngrx/store';
import {
  AlternativeSearchInput,
  AlternativeSearchResult,
  NeighbourMailInput,
  NeighbourMailResult, ValuationMailInput
} from "../assistants.model";
import {AgentProfile} from "@common/models/agent-profile";
import {AgentCompany} from "@common/models/agent-company";

export const CreateNeighbourMail = createAction(
  '[NeighbourMail] Create',
  props<{ input: NeighbourMailInput, agentProfile: AgentProfile, agentCompany: AgentCompany }>()
);

export const CreateNeighbourMailSucceeded = createAction(
  '[NeighbourMail] Create Succeeded',
  props<{ result: NeighbourMailResult }>()
);

export const CreateNeighbourMailFailed = createAction('[NeighbourMail] Create Failed');

export const CreateAlternativeSearch = createAction(
  '[AlternativeSearch] Create',
  props<{ input: AlternativeSearchInput, agentProfile: AgentProfile, agentCompany: AgentCompany }>()
);

export const CreateAlternativeSearchSucceeded = createAction(
  '[AlternativeSearch] Create Succeeded',
  props<{ result: AlternativeSearchResult }>()
);

export const CreateAlternativeSearchFailed = createAction('[AlternativeSearch] Create Failed');

export const CreateValuationMail = createAction(
  '[ValuationMail] Create',
  props<{ input: ValuationMailInput, agentProfile: AgentProfile, agentCompany: AgentCompany }>()
);

export const CreateValuationMailSucceeded = createAction(
  '[ValuationMail] Create Succeeded',
  props<{ result: NeighbourMailResult }>()
);

export const CreateValuationMailFailed = createAction('[ValuationMail] Create Failed');

